import React, { useState, useEffect } from 'react';
import axios from './axios';
import './Row.css';
import Youtube from 'react-youtube';
import movieTrailer from 'movie-trailer';

const baseImageURL = "https://image.tmdb.org/t/p/original/";

function Row( { title, fetchURL, isLargeRow } ) {
  
    const [movies, setMovies] = useState([]);
    const [trailerURL, setTrailerURL] = useState("");

    useEffect(() => {
        async function fetchData() {
            const request = await axios.get(fetchURL);
            setMovies(request.data.results);
            console.log(movies);
            return request;
        }
        fetchData();
    }, [fetchURL]);

    const opts = {
      height: '560',
      width: '100%',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        modestbranding: 1,
      },
    };

    const handleClick = (movie) => {
        console.log(movie?.title || movie?.name || movie?.original_name);
        if (trailerURL) {
            setTrailerURL('');
        } else {
            movieTrailer(movie?.title || movie?.name || movie?.original_name)
                .then((url) => {
                    console.log(url);
                    const urlParams = new URLSearchParams(new URL(url).search);
                    setTrailerURL(urlParams.get('v'));
                })
                .catch(error => console.log(error));
        }
    }

    return (
        <div className='row'>
            <h2>{title}</h2>
            <div className='row_posters'>
                {movies.map(movie => {
                    console.log(movie);
                    return(
                        <img 
                            key={movie.id}
                            onClick={() => handleClick(movie)}
                            className={`row_poster ${isLargeRow && "row_posterLarge"}`}
                            src={`${baseImageURL}${isLargeRow ? movie.poster_path : movie.backdrop_path}`}
                            alt={movie?.title || movie?.name || movie?.original_name}
                        />
                    )
                })}
            </div>
            {trailerURL && <Youtube videoId={trailerURL} opts={opts} />}
        </div>
    )
};

export default Row;